export const ACTIVE_ANALYSIS_PROVIDERS = ["groq", "gemini", "openrouter"] as const;

export type AnalysisProvider = typeof ACTIVE_ANALYSIS_PROVIDERS[number];

export function isActiveAnalysisProvider(value: unknown): value is AnalysisProvider {
  return typeof value === "string"
    && (ACTIVE_ANALYSIS_PROVIDERS as readonly string[]).includes(value);
}

export function normalizeAnalysisProvider(value: unknown): AnalysisProvider | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  return isActiveAnalysisProvider(normalized) ? normalized : null;
}

export function analysisProviderLabel(provider: AnalysisProvider): string {
  if (provider === "openrouter") return "OpenRouter";
  if (provider === "groq") return "Groq";
  return "Gemini";
}
